module.exports = __webpack_public_path__ + "img/utilities.2c630de7.jpg";